module.exports = __webpack_public_path__ + "img/f1d7874.svg";